export const LAST_UNREAD_MESSAGE_POPUP_EVENTS = {
  LAST_UNREAD_MESSAGE_POPUP_CLOSE: 'last-unread-message-popup-close',
};
